/* eslint-disable no-unused-vars */

import { Button, makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { Page } from 'src/components';
import { EventSubscriptionsTable } from './components/EventSubscriptionsTable';
import { EventsToolbar } from './components/EventsToolbar';
import { useNavigate } from 'react-router';
import { usePermissions } from 'src/hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1em'
  }
}));

export const EventSubscriptionsList: FC = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { canCreateEvent } = usePermissions();

  return (
    <Page className={classes.root} title="Event Subscriptions">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="textPrimary" gutterBottom variant="h3">
          Event Subscriptions
        </Typography>
        {canCreateEvent ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/app/event-subscriptions-create')}
          >
            Create Event
          </Button>
        ) : null}
      </div>
      <EventsToolbar />
      <EventSubscriptionsTable />
    </Page>
  );
};
